import { all, takeLatest } from "redux-saga/effects";
import httpClient from "../services/http.client";
import * as Effects from "redux-saga/effects";
import { errorMessage } from "../../utilities/notification";
import {
  AFFILIATEDASHBOARDCOUNT,
  DASHBOARDCOUNT,
  DASHBOARDORDERSTATS,
} from "../actions/stats.actions.types";

const call = Effects.call;

function* getDashboardCount({ payload: { callback } }) {
  const payload = {
    method: "get",
    url: "/stats/count",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    errorMessage("Failed to fetch dashboard count");
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}
function* affiliateDashboardCount({ payload: { id, callback } }) {
  const payload = {
    method: "get",
    url: id
      ? `/stats/affiliate-count?affiliateId=${id}`
      : `/stats/affiliate-count`,
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    errorMessage("Failed to fetch dashboard count");
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* getDashboardOrderStats({ payload: { callback } }) {
  const payload = {
    method: "get",
    url: "/stats/order",
  };

  const { error, result } = yield call(httpClient, {
    payload,
    isLoader: true,
    authorization: true,
  });

  if (error) {
    errorMessage("Failed to fetch order stats");
    if (callback) {
      callback({ success: false, data: null });
    }
  } else {
    if (callback) {
      callback({ success: true, data: result.data });
    }
  }
}

function* Stats() {
  yield all([
    takeLatest(DASHBOARDCOUNT, getDashboardCount),
    takeLatest(DASHBOARDORDERSTATS, getDashboardOrderStats),
    takeLatest(AFFILIATEDASHBOARDCOUNT, affiliateDashboardCount),
  ]);
}

export default Stats;
